/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Flex, List } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import { NextArrow, PrevArrow } from '@components/Sliders/TestimonialYs/Icons';
import TestimonialCard from '@components/Sliders/TestimonialYs/TestimonialCard';
import config from '@config';
//styles
import TopKolam from '@components/Headings/TopKolam';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

/**
 * Renders the Testimonial component.
 *
 * @returns {ReactElement} Testimonial component.
 */

const OtpTestimonials = ({ sectionContent, pageData }) => {
    console.log("otptesttt ", sectionContent?.[1])
    const [imgIndex, setImgIndex] = useState(0);
    const settings = {
        dots: true,
        infinite: true,
        arrows: true,
        lazyLoad: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        nextArrow: <NextArrow page={'otp'}/>,
        prevArrow: <PrevArrow page={'otp'}/>,
        className: "Yoga-SandhyaTestimonial",

        // centerMode: true,
        // centerPadding: '0px 40px',
        appendDots: dots => (
            <Box h="1px">
                <List margin='0px'> {dots} </List>
            </Box>
        ),
        customPaging: (i) => {
            return (
                <Box   
                    className='custom-dot'
                    width="14px"
                    rounded="full"
                    height="14px"
                ></Box>
            )
        },
        afterChange: (index) => setImgIndex(index),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 1065,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    // centerPadding: '0px 40px',

                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    // centerPadding: '0px 40px',

                }
            }
        ],
    };

    return (
        <Box
            w="100%"
            mx="auto"
            pb={{ base: "30px", md: "60px" }}
            background={"#fff"}
            pt={'0px'}
        >
            <Box display={"flex"} justifyContent={"center"}
                marginBottom={"130px"}
                marginTop={"30px"} position={"relative"} maxHeight={"350px"}>
                <Box position={"absolute"} top={{ base: "30px", sm: "30px", md: "25px", lg: "25px" }}>
                    <SectionTitle titleObj={sectionContent[0]} color={"#000000"} />
                </Box>
            </Box>
            <Flex
                w={{ base: '340px', sm: "380px", md: '570px', lg: "570px", xl: '1100px' }}
                // w="100%"
                mx="auto"
                pt={{base:'10px', md:"65px"}}
                pb={{base:'0px', md:'20px'}}
                justifyContent="center"
                flexDir="column"
                fontFamily={'FedraSansStd-book'}
                // alignItems="center"
                h={{ base: "550px", md: "450px" }}
                px={{ base: '0px', sm: '20px', md: '30px' }}

            >
                <Slider {...settings}>
                    {sectionContent[1]?.testimonials?.map(card => {
                        return <TestimonialCard card={card} key={nanoid()} otpTestimonials={true} />;
                    })}
                </Slider>
                <style>
                    {
                        `
                .Yoga-SandhyaTestimonial .slick-dots .slick-active div{
                    background:#CE4520A1;
                }
                .custom-dot {
                    background: #00000033; /* Default inactive color */
                }
                .slick-active .custom-dot {
                    background: #FFA735 !important; /* Active dot color */
                }
                `
                    }
                </style>
            </Flex>
        </Box>
    );
};

export default OtpTestimonials;